// extracted by mini-css-extract-plugin
export default {"filters":"AdminLogs_filters__BwJVo"};